export default {
  inputLabel: {
    id: 'bo_seller.listings.listings_table.inventory.units',
    defaultMessage: 'Units',
  },
  saveButton: {
    id: 'bo_seller.listings.listings_table.inventory.save_button',
    defaultMessage: 'Save',
  },
}
